import React from 'react';
import { TourDetailPage } from '../components/TourDetailPage';
import { worldwideTours } from '../data/tours';

export const NepalTourPage = () => {
  const tour = worldwideTours.find(t => t.id === 'nepal-spiritual-journey');
  return <TourDetailPage tour={tour} />;
};
